<template>
  <div class="mt-4">
    <a v-if="needContactButton" class="button-secondary block" :href="`tel:${ phoneNumber }`">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="inline w-4">
        <path d="m556.47567 279.782859-.775371-.608385c-.356217-.279146-.875557-.216638-1.155136.139573l-2.039685 2.600512c-.279579.356211-.216641.875971.139576 1.155117l1.113606.873831c-.423864.646916-.986447 1.359339-1.721144 2.093596-.734698.734685-1.447132 1.297687-2.094059 1.721544l-.873845-1.113588c-.278723-.356211-.798919-.419147-1.154708-.139573l-2.600983 2.039651c-.355789.279146-.418726.799334-.139576 1.155117l.608395.775358c1.337526 1.337504 4.815351.028257 7.768269-2.924612 2.952491-2.952442 4.262188-6.430637 2.924661-7.768141" transform="translate(-544 -278)"/>
      </svg>
      {{$t('tour_call')}}
    </a>
    <div class="text-center pb-2">
      <p v-for="link in links" v-bind:key="link.id" v-bind:value="link.id" class="py-1 text-sm">
        {{ link.text }}
        <a :href="`tel:${ phoneNumber }`" class="underline">{{ link.phone }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import Constants from "@/constants";

export default {
  computed: {
    contact: function () {
      const serviceAreaId = parseInt(this.$route.query.serviceAreaId)
      const s = Constants.DOCOMO_SERVICE_AREAS.find((s) => s.id == serviceAreaId)
      return s && s.contact
    },
    needContactButton: function (){
      return this.contact && this.contact.needButton
    },
    phoneNumber: function () {
      return this.links[0] && this.links[0].phone
    },
    links: function () {
      return this.contact ? this.contact.links : []
    }
  }
}
</script>
